webpackJsonp([93],{

/***/ "JO6v":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-company-info_8f30a408b2003b1a1066411540e49517.html";

/***/ }),

/***/ "s9xa":
/***/ (function(module, exports, __webpack_require__) {

var SectionCompanyInfo = (function () {
    function SectionCompanyInfo() {
    }
    return SectionCompanyInfo;
}());
angular.module('animatronApp.sectionCompanyInfo', []).component('sectionCompanyInfo', {
    bindings: {
        ltTitle: '<',
        title2: '<',
        logoUrl: '<',
        logoAlt: '<',
        description: '<',
        background: '<',
        list: '<'
    },
    controller: SectionCompanyInfo,
    templateUrl: __webpack_require__("JO6v")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/93-257c10c0995a4d25fa59.min.js